// extracted by mini-css-extract-plugin
module.exports = {"spaceTop":"Tabs_spaceTop__2SBQS"};